import { IKeyframeItem } from "@/types/summary";

interface IProps {
  displayKeyframes: IKeyframeItem[];
  hiddenKeyframesLen: number;
  className?: string;
  handlePreview: (keyframeIndex?: number) => void;
  index: number;
}
const Keyframe: React.FC<IProps> = ({
  displayKeyframes,
  hiddenKeyframesLen,
  className,
  handlePreview,
  index
}) => {
  return (
    displayKeyframes?.length > 0 && (
      <div className={`flex mt-2 items-center ${className}`} key={index}>
        {displayKeyframes?.map((item, itemIndex) => {
          const isLastOne = itemIndex === displayKeyframes.length - 1;
          return (
            <div
              className={`relative max-w-[calc((100%-1rem)/3)] flex items-center justify-center rounded-1.5 ${
                !isLastOne && "mr-2"
              } cursor-pointer`}
              onClick={() => handlePreview(item.keyframeIndex)}
              key={item.keyframeIndex}
            >
              <img
                src={item.keyFrameUrl}
                className="w-full h-full rounded-1.5 object-contain"
              />
              {isLastOne && hiddenKeyframesLen > 0 && (
                <div className="absolute w-full h-full flex items-center justify-center top-0 left-0 rounded-1.5 color-#fff text-5 text-center bg-#000/30">
                  {`+${hiddenKeyframesLen}`}
                </div>
              )}
            </div>
          );
        })}
      </div>
    )
  );
};

export default Keyframe;
